module.exports = __webpack_public_path__ + "img/20180815_151844_213.17fa962d.jpg";